import _ from 'lodash';
import { connect } from 'react-redux';

import Home from '../component/Home';
import actions from '../redux/actions/statistic';

const mapStateToProps = (state) => ({
  trans: state.statistic.trans,
  extTrans: state.statistic.extTrans,
  orderTrans: state.statistic.orderTrans,
  coins: state.setting.arrCoins,
  markets: _.values(state.setting.currencyMarkets).flat(),
});

const mapDispatchToProps = (dispatch) => ({
  fetchTrans: (params) => {
    dispatch(actions.fetchTransAction(params));
  },
  fetchExtTrans: (params) => {
    dispatch(actions.fetchExtTransAction(params));
  },
  fetchOrderTrans: (params) => {
    dispatch(actions.fetchOrderTransAction(params));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
